import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';

interface ErrorScreenProps {
  error: string;
  onRetry: () => void;
  onShowDemo?: () => void;
  debugInfo?: any;
}

const ErrorScreen: React.FC<ErrorScreenProps> = ({ 
  error, 
  onRetry, 
  onShowDemo,
  debugInfo 
}) => {
  const handleViewConsole = () => {
    alert('Please open your browser\'s Developer Tools (F12) and check the Console tab for detailed error information.');
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center w-full p-4">
      <div className="text-center max-w-md mx-auto px-4">
        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <AlertCircle className="w-8 h-8 text-red-500" />
        </div>
        
        <h2 className="font-heading text-xl font-semibold text-neutral-800 mb-2">
          Cemetery Not Found
        </h2>
        
        <p className="font-body text-neutral-600 mb-6">
          {error}
        </p>
        
        <button
          onClick={onRetry}
         className="bg-tenant-primary text-white px-6 py-3 rounded-lg font-body font-medium hover:bg-tenant-accent transition-colors flex items-center mx-auto"
        >
          <RefreshCw className="w-4 h-4 mr-2" />
          Try Again
        </button>
        
        {onShowDemo && (
          <button
            onClick={onShowDemo}
            className="mt-3 bg-blue-500 text-white px-6 py-3 rounded-lg font-body font-medium hover:bg-blue-600 transition-colors flex items-center mx-auto"
          >
            Try Demo Mode
          </button>
        )}
        
        <button
          onClick={handleViewConsole}
          className="mt-3 bg-gray-500 text-white px-6 py-3 rounded-lg font-body font-medium hover:bg-gray-600 transition-colors flex items-center mx-auto"
        >
          <AlertCircle className="w-4 h-4 mr-2" />
          View Debug Info
        </button>
        
        <div className="mt-6 p-4 bg-blue-50 rounded-lg">
          <p className="font-body text-sm text-blue-700">
            <strong>Tip:</strong> Make sure you're visiting the correct subdomain (e.g., gmct.localhost:5173)
          </p>
        </div>
        
        {process.env.NODE_ENV === 'development' && debugInfo && (
          <details className="mt-4">
            <summary className="cursor-pointer text-sm text-gray-600">
              Debug Information
            </summary>
            <pre className="mt-2 text-xs bg-gray-100 p-2 rounded overflow-auto">
              {JSON.stringify(debugInfo, null, 2)}
            </pre>
          </details>
        )}
      </div>
      
      <div className="fixed bottom-4 right-4 bg-gray-800 text-white p-2 rounded text-xs font-mono max-w-xs">
        <div>Hostname: {window.location.hostname}</div>
        <div>URL: {window.location.href}</div>
        <div>Supabase: {import.meta.env.VITE_SUPABASE_URL || 'MISSING'}</div>
      </div>
    </div>
  );
};

export default ErrorScreen;